import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { ParallaxProvider } from 'react-scroll-parallax';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/layout/layout.component';
import Home from './components/home.component';
// import Services from './components/services.component';
// import Solutions from './components/solutions.component';
import CaseStudies from './components/case-studies.compoent';
import AboutUs from './components/about-us.component';
import ServiceRequest from './components/service-request.component';
import { getTheme } from './theme/theme';
import { useState } from 'react';
// import HomePage from './components/home-page.component';
import { Services } from './components/services';
import { Contact } from './components/contact';
import { Solutions } from './components/solutions';
import Seo from './components/seo';

const App = () => {
  const [mode, setMode] = useState('dark');
  const theme = getTheme(mode);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  return (
    <>
      <Seo />
      <ThemeProvider theme={theme}>
        <ParallaxProvider>
          <Box
            sx={{
              bgcolor: 'background.default',
              color: 'text.primary',
              minHeight: '100vh',
            }}
          >
            <Layout mode={mode} toggleTheme={toggleTheme}>
              <Routes>
                <Route path="/" element={<Home mode={mode} />} />
                <Route path="/services" element={<Services mode={mode} />} />
                <Route path="/solutions" element={<Solutions mode={mode} />} />
                <Route path="/case-studies" element={<CaseStudies mode={mode} />} />
                <Route path="/about" element={<AboutUs mode={mode} />} />
                <Route path="/contact" element={<Contact mode={mode} />} />
                <Route path="/service-request" element={<ServiceRequest mode={mode} />} />
              </Routes>
            </Layout>
          </Box>
        </ParallaxProvider>
      </ThemeProvider>
    </>
  );
}

export default App;